'use strict';

var _interopRequireDefault = require('@babel/runtime/helpers/interopRequireDefault');
Object.defineProperty(exports, '__esModule', {
	value: true
});
exports['default'] = void 0;
var _regenerator = _interopRequireDefault(require('@babel/runtime/regenerator'));
var _asyncToGenerator2 = _interopRequireDefault(require('@babel/runtime/helpers/asyncToGenerator'));
var _slicedToArray2 = _interopRequireDefault(require('@babel/runtime/helpers/slicedToArray'));
var _react = require('react');
var _core = require('@sei-js/core');
var _provider = require('../../provider');
var useSigningCosmWasmClient = function useSigningCosmWasmClient(customRpcUrl) {
	var _useContext = (0, _react.useContext)(_provider.SeiWalletContext),
		offlineSigner = _useContext.offlineSigner,
		rpcUrl = _useContext.rpcUrl,
		chainId = _useContext.chainId;
	var _useState = (0, _react.useState)(true),
		_useState2 = (0, _slicedToArray2['default'])(_useState, 2),
		isLoading = _useState2[0],
		setIsLoading = _useState2[1];
	var _useState3 = (0, _react.useState)(),
		_useState4 = (0, _slicedToArray2['default'])(_useState3, 2),
		signingCosmWasmClient = _useState4[0],
		setSigningCosmWasmClient = _useState4[1];
	(0, _react.useEffect)(
		function () {
			var getClient = /*#__PURE__*/ (function () {
				var _ref = (0, _asyncToGenerator2['default'])(
					/*#__PURE__*/ _regenerator['default'].mark(function _callee() {
						var client;
						return _regenerator['default'].wrap(
							function _callee$(_context) {
								while (1)
									switch ((_context.prev = _context.next)) {
										case 0:
											_context.prev = 0;
											if (!(!rpcUrl || !offlineSigner || !chainId)) {
												_context.next = 3;
												break;
											}
											return _context.abrupt('return');
										case 3:
											setIsLoading(true);
											_context.next = 6;
											return (0, _core.getSigningCosmWasmClient)(customRpcUrl || rpcUrl, offlineSigner);
										case 6:
											client = _context.sent;
											setSigningCosmWasmClient(client);
											setIsLoading(false);
											_context.next = 14;
											break;
										case 11:
											_context.prev = 11;
											_context.t0 = _context['catch'](0);
											console.error('Error creating signing cosmwasm client');
										case 14:
										case 'end':
											return _context.stop();
									}
							},
							_callee,
							null,
							[[0, 11]]
						);
					})
				);
				return function getClient() {
					return _ref.apply(this, arguments);
				};
			})();
			getClient();
		},
		[customRpcUrl, rpcUrl, chainId, offlineSigner]
	);
	return {
		signingCosmWasmClient: signingCosmWasmClient,
		isLoading: isLoading
	};
};
var _default = (exports['default'] = useSigningCosmWasmClient);
//# sourceMappingURL=useSigningCosmWasmClient.js.map
